import React, { useEffect, useState } from 'react';
import {
    MDBBtn, MDBCol, MDBIcon, MDBInput, MDBRow,
    MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter,
    MDBTextArea, MDBCheckbox,
    MDBInputGroup,
    MDBSelect,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
} from 'mdb-react-ui-kit';
import { createClass, getCategory, getGymPlansList, logEvent } from '../../services/classApiServices.js';
import { isEmpty } from "../../validators/helper.js";
import ReactQuill from 'react-quill';
import DiscountRow from '../../views/DiscountRow.js';
import UploadLogo from '../../views/uploadLogo.js';

function CreateClass(props) {

    const [discounts, setDiscounts] = useState([
        { selectedPlans: [], discount: '', checked: true },
    ]);
    const [classCategory, setClassCategory] = useState([])
    const [error, setError] = useState({});
    const [classData, setClassData] = useState({
        name: '',
        duration: '',
        slots: '',
        price: '',
        category: 'Yoga',
        level: 'Beginner',
        discounts: [],
        description: '',
        classurl: "",
        requireWaiver: false
    });
    const [alertModal, setAlertModal] = useState(false);
    console.log(classData, "classData");
    const toggleAlertModal = () => setAlertModal(!alertModal);
    const [plans, setPlans] = useState([])

    const [selectedAddons, setSelectedAddons] = useState([]);


    const [volumeDiscounts, setVolumeDiscounts] = useState([
        { minParticipants: '', discount: '', checked: true }
    ]);

    // Volume discount handlers
    const handleVolumeDiscountChange = (index, field, value) => {
        const updatedDiscounts = [...volumeDiscounts];
        updatedDiscounts[index][field] = value;
        setVolumeDiscounts(updatedDiscounts);
    };

    const handleVolumeDiscountCheck = (index, isChecked) => {
        const updatedDiscounts = [...volumeDiscounts];
        updatedDiscounts[index].checked = isChecked;
        setVolumeDiscounts(updatedDiscounts);
    };

    const handleAddVolumeDiscount = () => {
        setVolumeDiscounts([
            ...volumeDiscounts,
            { minParticipants: '', discount: '', checked: true }
        ]);
    };

    const handleRemoveVolumeDiscount = (index) => {
        const updatedDiscounts = volumeDiscounts.filter((_, i) => i !== index);
        setVolumeDiscounts(updatedDiscounts);
    };


    useEffect(() => {

        async function fetchPlans() {
            if (!props.plansinfo) return;
            setPlans(props.plansinfo)
        }

        fetchPlans();

    }, [props.plansinfo]);

    useEffect(() => {

        async function fetchData() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getCategory(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (!response) {
                    return;
                }
                if (response === "false") {
                    // setApiError(true)
                } else {
                    const tempData = await response.json();
                    console.log(tempData);
                    setClassCategory(tempData);

                }

            }
        }


        fetchData();

    }, []);
    useEffect(() => {
        function fetchData() {
            if (!props.classinfo) return;

            const { membershipdiscount, addons, volumediscount, ...rest } = props.classinfo;

            const grouped = [];
            const map = new Map();

            for (const item of membershipdiscount) {
                const key = `${item.discount}-${item.checked}`;
                if (!map.has(key)) {
                    map.set(key, {
                        selectedPlans: [],
                        discount: item.discount,
                        checked: item.checked
                    });
                }
                map.get(key).selectedPlans.push(item.membershipname);
            }

            grouped.push(...map.values());

            setDiscounts(grouped);

            if (addons && Array.isArray(addons)) {
                const addonIds = addons.map(addon => addon._id);
                setSelectedAddons(addonIds);
            }


            if (volumediscount && Array.isArray(volumediscount)) {
                const formattedVolumeDiscounts = volumediscount.map(discount => ({
                    minParticipants: discount.minParticipants?.toString() || '',
                    discount: discount.discount?.toString() || '',
                    checked: discount.checked !== false // Default to true if not specified
                }));
                setVolumeDiscounts(formattedVolumeDiscounts);
            } else {
                // Initialize with empty if no volume discounts exist
                setVolumeDiscounts([{ minParticipants: '', discount: '', checked: true }]);
            }


            setClassData({
                ...rest,
                discounts: membershipdiscount
            });


        }

        fetchData();
    }, [props.classinfo]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setClassData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };



    const handleAddonChange = (selectedItems) => {
        try {
            // MDBSelect passes an array of objects with {text, value} format
            // Extract just the IDs (value field)
            let selectedIds = [];

            if (Array.isArray(selectedItems)) {
                selectedIds = selectedItems.map(item => item.value);
            } else if (selectedItems && typeof selectedItems === 'object') {
                // Handle single selection or other formats
                if (selectedItems.value) {
                    selectedIds = [selectedItems.value];
                }
            }

            // Store only the IDs in selectedAddons
            setSelectedAddons(selectedIds);
        } catch (error) {
            console.error("Error in handleAddonChange:", error);
            setSelectedAddons([]);
        }
    };


    const handleDescriptionChange = (value) => {
        setClassData((prevData) => ({
            ...prevData,
            description: value
        }));
    };


    const handleDiscountChange = (index, field, value) => {
        const updatedDiscounts = [...discounts];
        if (field === "selectedPlans") {
            updatedDiscounts[index][field] = value; // directly IDs
        } else {
            updatedDiscounts[index][field] = value;
        }
        setDiscounts(updatedDiscounts);
    };


    const handleCheckboxChange = (index, isChecked) => {
        const updatedDiscounts = [...discounts];
        updatedDiscounts[index].checked = isChecked;
        setDiscounts(updatedDiscounts);
    };

    const handleAddDiscount = () => {
        setDiscounts([...discounts, { selectedPlans: [], discount: '', checked: true }]);
    };

    const handleRemoveDiscount = index => {
        const updatedDiscounts = [...discounts];
        updatedDiscounts.splice(index, 1);
        setDiscounts(updatedDiscounts);
    };

    

    const addDiscountRow = () => {
        setDiscounts([...discounts, { membershipname: '', discount: '', checked: false }]);
    };

    const removeDiscountRow = (index) => {
        const updatedDiscounts = discounts.filter((_, i) => i !== index);
        setDiscounts(updatedDiscounts);
    };

    let validateForm = (e) => {
        console.log("Validating form...");
        let errors = {};

        if (isEmpty(classData.name)) {
            errors.name = "Class Name can't be blank";
        }
        if (isEmpty(classData.duration)) {
            errors.duration = "Duration can't be blank";
        } else if (Number(classData.duration) < 15 || Number(classData.duration) > 999) {
            errors.duration = "Duration must be with in the range of (15-999) "
        }

        if (isEmpty(classData.price)) {
            errors.price = "Price can't be blank";
        }
        if (isEmpty(classData.slots)) {
            errors.slots = "Slots can't be blank"
        } else if (Number(classData.slots) < 1 || Number(classData.slots) > 99) {
            errors.slots = "Slots must be with in the range of (1-99) "
        }
        // if (classData.length === 0) {
        //     errors.slots = "Please select at least one slot";
        // }
        // if (classData.length === 0) {
        //     errors.weekday = "Please select at least one  day";
        // }
        console.log(errors);
        if (isEmpty(errors)) {
            return true;
        } else {
            return errors;
        }
    };

    const handleSubmit = async (e, applied) => {
        e.preventDefault();

        try {
            const expandedDiscounts = discounts.flatMap(group =>
                group.checked
                    ? group.selectedPlans.map(planId => ({
                        membershipname: planId,
                        discount: group.discount,
                        checked: true
                    }))
                    : []
            );

            const volumediscountfilter = volumeDiscounts
                .filter(d => d.minParticipants && d.discount)
                .map(d => ({
                    minParticipants: parseInt(d.minParticipants),
                    discount: parseFloat(d.discount),
                    checked: d?.checked

                }))

            const formattedAddons = (selectedAddons || []).map(id => ({
                _id: id
            }));

            const prevClassName = classData?.name || "";
            const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1;
            const update = {
                name: classData.name,
                category: classData.category,
                bid: gymid,
                duration: classData.duration,
                description: classData.description || "",
                membershipdiscount: expandedDiscounts.filter((discount) => discount.checked),
                slots: classData.slots,
                level: classData.level,
                price: classData.price,
                classurl: classData.classurl,
                isapplyall: applied ? applied : null,
                _id: classData._id,
                addons: formattedAddons,
                volumediscount: volumediscountfilter,
                requireWaiver: classData.requireWaiver ?? false

            }
            console.log(update, '11111111111111111111111111111111');

            let noerrors = validateForm(e);
            console.log(noerrors);
            if (noerrors === true) {

                const response = await createClass(gymid, update)

                props.onSave(!!classData._id, prevClassName);
            } else {
                setError(noerrors);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const [selectData, setSelectData] = useState([
        { text: 'Select', value: "Select" },

    ]);
    useEffect(() => {
        const itemSet = new Set();


        plans.length > 0 && plans.forEach(item => {
            if (item._id && item._id.length > 0) {
                itemSet.add({ text: item.name, name: item._id });
            }
        });
        console.log(itemSet);
        const uniqueitem = Array.from(itemSet);
        console.log(uniqueitem);
        const formatteditem = uniqueitem.map(item => ({
            text: item.text,
            value: item.name
        }));
        console.log(formatteditem);


        setSelectData(formatteditem);
    }, [plans]);
    console.log(selectData, 'selectData');

    const handleUrl = (data) => {
        setClassData((prevData) => ({
            ...prevData,
            ["classurl"]: data
        }));
    }

    const handleApplyToAll = (e) => {
        // setIsapplied(true)
        setAlertModal(false)
        handleSubmit(e, true)
    }
    const handleCancel = (e) => {
        setAlertModal(false)
    }

    const handleApplyToOne = (e) => {
        setAlertModal(false)
        handleSubmit(e, false)
    }

    return (
        <div>
            <MDBModalHeader>
                <MDBModalTitle>{props.classinfo ? "Update Class" : "Add Class"}</MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={props.onclose}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>

                <div>
                    <label htmlFor="className" className='fw-bold mb-2'>Class Name<span className="text-danger">*</span></label>
                    <div> <MDBInput
                        type="text"
                        name="name"
                        placeholder="e.g., Morning Yoga Flow"
                        value={classData.name}
                        onChange={handleChange}
                    />{error.name && (
                        <>
                            <p className="clr-red">{error.name}</p>
                        </>
                    )}</div>
                </div>

                <MDBRow className='mt-2'>
                    <MDBCol sm={12} md={4} lg={4}>
                        <div className="form-group">
                            <label className='fw-bold mb-2'>Duration (15-999 min)<span className="text-danger">*</span></label>
                            <div> <MDBInput
                                type="number"
                                name="duration"
                                min="15"
                                max="999"
                                placeholder='Enter duration'
                                value={classData.duration}
                                onChange={handleChange}
                            />  {error.duration && (
                                <>
                                    <p className="clr-red">{error.duration}</p>
                                </>
                            )}</div>
                        </div>
                    </MDBCol>

                    <MDBCol sm={12} md={4} lg={4}>
                        <div className="form-group">
                            <label className='fw-bold mb-2'>Maximum Capacity (1-99)<span className="text-danger">*</span></label>
                            <div>
                                <MDBInput
                                    type="number"
                                    name="slots"
                                    min="1"
                                    max="99"
                                    placeholder='Enter Maximum Capacity'
                                    value={classData.slots}
                                    onChange={handleChange}
                                />
                                {error.slots && (
                                    <>
                                        <p className="clr-red">{error.slots}</p>
                                    </>
                                )}</div>
                        </div>
                    </MDBCol>

                    <MDBCol sm={12} md={4} lg={4}>
                        <div className="form-group">
                            <label className='fw-bold mb-2'>Price ($)<span className="text-danger">*</span></label>
                            <div>  <MDBInput
                                type="number"
                                name="price"

                                step="0.01"
                                placeholder='Enter Price'
                                value={classData.price}
                                onChange={handleChange}
                            /> {error.price && (
                                <>
                                    <p className="clr-red">{error.price}</p>
                                </>
                            )}</div>
                        </div>
                    </MDBCol>
                </MDBRow>

                <MDBRow className='mt-2'>
                    <MDBCol sm={12} md={8} lg={8}>
                        <div className="form-group">
                            <label className='fw-bold mb-2'>Category</label>
                            <select
                                className="form-select"
                                name="category"
                                value={classData.category}
                                onChange={handleChange}
                            >
                                <option value="">Select a category</option>
                                {classCategory.map((cat) => (
                                    <option key={cat._id} value={cat.name}>
                                        {cat.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </MDBCol>

                    <MDBCol sm={12} md={4} lg={4}>
                        <div className="form-group">
                            <label className='fw-bold mb-2'>Level</label>
                            <select
                                className="form-select"
                                name="level"
                                value={classData.level}
                                onChange={handleChange}
                            >
                                <option value="Beginner">Beginner</option>
                                <option value="Intermediate">Intermediate</option>
                                <option value="Advanced">Advanced</option>
                                <option value="All Levels">All Levels</option>
                            </select>
                        </div>
                    </MDBCol>
                </MDBRow>


                <MDBRow className="mt-2">
                    <MDBCol sm={12} md={12} lg={12}>
                        <div className="slot-foot mb-2">
                            <div className="col-md-4 d-flex flex-row align-items-center my-0">
                                <label className="mb-0 switchlabel me-3">
                                    Waiver:
                                </label>

                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={classData?.requireWaiver || false}
                                        onChange={() =>
                                            handleChange({
                                                target: {
                                                    name: "requireWaiver",
                                                    value: !classData?.requireWaiver,
                                                },
                                            })
                                        }
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>

                        </div>
                    </MDBCol>
                </MDBRow>



                <div className="mt-4">
                    <div className="d-flex align-items-center justify-content-between">
                        <label htmlFor="" className="fw-bold">
                            Addons
                        </label>
                    </div>

                    {props.addonsinfo && props.addonsinfo.length > 0 ? (
                        <div className="my-2">
                            <div className="d-flex align-items-center w-100">
                                <div className="flex-grow-1 me-2">

                                    <MDBSelect
                                        className="select-customdropdown"
                                        clearButton
                                        placeholder="Select Addons"
                                        multiple
                                        // search
                                        data={props.addonsinfo
                                            .filter(addon => addon.enable)
                                            .map(addon => {
                                                const price = addon.props?.[0]?.propvalue || "0";

                                                return {
                                                    text: `${addon.name} ₹${price}`,
                                                    value: addon._id
                                                };
                                            })
                                        }
                                        value={selectedAddons}
                                        onChange={handleAddonChange}
                                    />


                                </div>
                            </div>

                            {/* Show selected addons summary */}
                            {selectedAddons.length > 0 && (
                                <div className="mt-2">
                                    {/* <p className="mb-1 text-muted">
                                        <strong>Selected Addons:</strong> {selectedAddons.length} addon(s) selected
                                    </p>
                                    <div className="d-flex flex-wrap gap-2">
                                        {selectedAddons.map(addon => (
                                            <MDBChip key={addon._id} className="mb-2">
                                                {addon.name}
                                                {addon.price && addon.price !== "0" && ` ($${addon.price})`}
                                            </MDBChip>
                                        ))}
                                    </div> */}
                                </div>
                            )}
                        </div>
                    ) : (
                        <p className="text-muted mt-2">No addons available</p>
                    )}



                </div>





                <div className="mt-2">
                    <div className="d-flex align-items-center justify-content-between">
                        <label htmlFor="" className="fw-bold">
                            Membership Discounts
                        </label>
                        {/* <MDBBtn color="success" size="sm" onClick={addDiscountRow}> */}
                        <MDBBtn color="success" size="sm" onClick={handleAddDiscount}>

                            + Add Discount
                        </MDBBtn>
                    </div>
                  

                    {discounts.map((discount, index) => {
                        const allSelectedPlans = discounts.flatMap((d, i) =>
                            i !== index ? d.selectedPlans : []
                        );
                        const availablePlans = plans
                            .filter(plan =>
                                !plan.archived &&
                                (!allSelectedPlans.includes(plan._id) || discount.selectedPlans.includes(plan._id))
                            )
                            .flatMap(plan => {
                                if (plan.subplans && plan.subplans.length > 0) {
                                    return plan.subplans
                                        .filter(sub => !sub.archived)
                                        .map(sub => ({
                                            text: `${plan.name} - ${sub.name} (plan)`,
                                            value: sub._id
                                        }));
                                }
                                return [{ text: plan.name, value: plan._id }];
                            });



                        return (
                            <div className="my-2 d-flex align-items-center" key={index}>
                                <MDBCheckbox
                                    name={`discountActive${index}`}
                                    id={`discountActive${index}`}
                                    checked={discount.checked}
                                    onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                                />
                                <div className="d-flex align-items-center ms-2 w-100">

                                    <div className="flex-grow-1 me-2">
                                        <DiscountRow
                                            selectData={availablePlans}
                                            value={discount.selectedPlans}
                                            onChange={(vals) => handleDiscountChange(index, "selectedPlans", vals)}
                                        />

                                    </div>
                                    <div className="w-20">
                                        <MDBInputGroup className='group_text' textAfter={['%']} >
                                            <input className='form-control' type='number' placeholder="Discount" value={discount.discount}
                                                onChange={(e) => handleDiscountChange(index, 'discount', e.target.value)} />

                                        </MDBInputGroup>
                                    </div>
                                    <MDBBtn
                                        color="danger"
                                        className="ms-2 py-2"
                                        onClick={() => removeDiscountRow(index)}
                                    >
                                        Remove
                                    </MDBBtn>
                                </div>
                            </div>
                        );
                    })}
                </div>

                

                {/* Volume Discounts Section */}
                <div className="mt-4">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <label className="fw-bold mb-0">Volume Discounts</label>

                        <MDBBtn color="success" size="sm" onClick={handleAddVolumeDiscount}>
                            + Add Discount
                        </MDBBtn>
                    </div>

                    {/* Discount Rows */}
                    {volumeDiscounts.map((discount, index) => (
                        <div
                            key={index}
                            className="d-flex align-items-center mb-3"
                        >

                            <MDBCheckbox className='me-3'
                                name={`volumeDiscountActive${index}`}
                                id={`volumeDiscountActive${index}`}
                                checked={discount.checked}
                                onChange={(e) => handleVolumeDiscountCheck(index, e.target.checked)}
                            />

                            {/* Min Participants */}
                            <div style={{ width: "240px" }}>
                                <MDBInput
                                    type="number"
                                    min="1"
                                    placeholder="Participants"
                                    value={discount.minParticipants}
                                    onChange={(e) =>
                                        handleVolumeDiscountChange(
                                            index,
                                            "minParticipants",
                                            e.target.value
                                        )
                                    }

                                    onFocus={(e) => (e.target.onwheel = () => false)}
                                    onBlur={(e) => (e.target.onwheel = null)}
                                />
                            </div>

                            <div className="mx-3 text-muted" style={{ fontSize: "14px" }}>
                                participants  or more
                            </div>

                            {/* Discount */}
                            <div style={{ width: "200px" }}>
                                <MDBInput
                                    type="number"
                                    min="0"
                                    max="100"
                                    placeholder="Discount"
                                    value={discount.discount}
                                    onChange={(e) =>
                                        handleVolumeDiscountChange(
                                            index,
                                            "discount",
                                            e.target.value
                                        )
                                    }

                                    onFocus={(e) => (e.target.onwheel = () => false)}
                                    onBlur={(e) => (e.target.onwheel = null)}
                                />
                            </div>

                            <span className="ms-2 text-muted">%</span>

                            {/* Delete */}
                            <MDBIcon
                                icon="trash"
                                className="text-danger ms-3 cursor-pointer"
                                onClick={() => handleRemoveVolumeDiscount(index)}
                            />
                        </div>
                    ))}

                    {/* Empty State */}
                    {volumeDiscounts.length === 0 && (
                        <div className="alert alert-info mt-3">
                            <MDBIcon icon="info-circle" className="me-2" />
                            No volume discounts added yet.
                        </div>
                    )}
                </div>


                <div className="mt-2">
                    <ReactQuill
                        name="description"
                        placeholder="Describe what students can expect from this class"
                        value={classData.description}
                        onChange={handleDescriptionChange}
                    />
                </div>
                <div className="">
                    <UploadLogo handleUrl={handleUrl} Gid={JSON.parse(localStorage.getItem("loggedUserInfo")).gymid} imageurl={classData?.classurl ? classData?.classurl : null} from={"class"} />
                </div>
                <MDBModalFooter className='pe-2 pb-2'>
                    <MDBBtn color='secondary' onClick={props.onclose}>
                        Close
                    </MDBBtn>
                    <MDBBtn type="submit"
                        // onClick={handleSubmit}
                        onClick={(classData._id !== -1) ? toggleAlertModal : handleSubmit}
                    >{props.classinfo ? "Update" : "Save"}</MDBBtn>
                </MDBModalFooter>

            </MDBModalBody>

            <MDBModal tabIndex="-1" open={alertModal} onClose={toggleAlertModal}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Confirm Changes</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={toggleAlertModal}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>Do you want to apply these changes to all recurring events or only this event?</p>
                        </MDBModalBody>
                        <MDBModalFooter className='pe-2 pb-2'>
                            <MDBBtn color="secondary" onClick={handleCancel}>
                                Cancel
                            </MDBBtn>
                            <MDBBtn color="primary" onClick={handleApplyToAll}>
                                Apply to ALL existing Events
                            </MDBBtn>
                            <MDBBtn color="primary" onClick={handleApplyToOne}>
                                Apply only future Events
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    );
}

export default CreateClass;
